export function getDateFacetSetSliceInitialState(request, tabs) {
    return { request, tabs };
}
export function getDateFacetSetInitialState() {
    return {};
}
